import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestCustomfieldService } from './service/request-customfield.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { CommonModule } from '@angular/common';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { JsonDynamicFieldComponent } from 'src/app/page_component/json-dynamic-field/json-dynamic-field.component';

@Component({
	standalone: true,
	imports: [CommonModule, DotBounceLoadingEffectModule, GenericFormGenModule, JsonDynamicFieldComponent],
	selector: 'pcp-request-customfield',
	templateUrl: './request-customfield.component.html',
	styleUrls: ['./request-customfield.component.scss'],
})
export class RequestCustomfieldComponent implements OnInit, OnChanges {
	labels: LabelsInterface = {
		lbl_geral_campos_customizados: 'Customfields',
		lbl_geral_selecione: 'Select',
	};

	constructor(
		private RequestCustomfieldService: RequestCustomfieldService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService
	) {}

	isLoadingLabels = true;

	_isCustomfieldLoading = true;
	@Output() isCustomfieldLoading = new EventEmitter();

	@Input() idTopic: string;
	@Input() idCategory: string;
	@Input() idSolutionArea: string;

	@Input() idRequest: string;

	@Input() verifyFields = false;

	_isCustomfieldFulfilled = false;
	@Output() isCustomfieldFulfilled = new EventEmitter();

	@Input() setCustomfields: genericFormInterface[];

	_customfields: genericFormInterface[] = [];
	@Output() customfields = new EventEmitter();
	customfieldDictionary = {};

	@Input() disabled = false;
	@Input() ignoreAnalystView = false;
	isAnalystView = false;

	ngOnInit(): void {
		this.isAnalystView = localStorage.getItem('sessionStatus') === '1';
		if (!this.setCustomfields && (!this.idTopic || !this.idCategory || !this.idSolutionArea) && !this.idRequest) {
			this.NotificationService.setNotificationMessage('** Informations for customfield to initialize were not given');
			throw new Error('Informations for customfield to initialize were not given');
		}

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		if (this.setCustomfields) {
			this._customfields = this.setCustomfields.map((customfield) => {
				if (!this.ignoreAnalystView && customfield.analystView == true && !this.isAnalystView) customfield.hidden = true;
				return customfield;
			});
			this.getCustomfieldByCustomfield();
		} else if (this.idTopic && this.idCategory && this.idSolutionArea) {
			this.getCustomfieldsByClassification();
		} else if (this.idRequest) {
			this.getCustomfieldsByRequest();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.verifyFields && changes.verifyFields.currentValue == true) {
			this.verifyCustomfieldValues(true);
			this.verifyFields = false;
		}

		if (changes && changes.disabled) {
			this.lockFields(changes.disabled.currentValue);
		}

		if (changes && changes.setCustomfields && changes.setCustomfields.firstChange == false) {
			this._customfields = this.setCustomfields.map((customfield) => {
				if (!this.ignoreAnalystView && customfield.analystView == true && !this.isAnalystView) customfield.hidden = true;
				return customfield;
			});
			this.getCustomfieldByCustomfield();
		}
	}

	verifyCustomfieldValues(turnAlerts: boolean): void {
		let isEverythingOk = true;
		for (const customfield of this._customfields) {
			if (
				customfield.hidden == false &&
				customfield.required == true &&
				(!customfield.values[0] ||
					customfield.values[0].toString().trim() == '' ||
					(customfield.inputType.toLowerCase() == 'select' && customfield.values[0].toString() == '-1') ||
					(customfield.inputType.toLowerCase() == 'select-iac' && customfield.values[0].toString() == '-1') ||
					(customfield.inputType.toLowerCase() == 'select-approver' && customfield.values[0].toString() == '-1') ||
					(customfield.inputType.toLowerCase() == 'checkbox' && !customfield.values.includes(1)) ||
					(customfield.rawInputType?.toLowerCase() == 'json_dynamic' &&
						(!customfield.values[0] || customfield.values[0].toString().trim() == '')))
			) {
				if (turnAlerts) customfield.alert = true;
				isEverythingOk = false;
			} else {
				customfield.alert = false;
			}
		}

		this._isCustomfieldFulfilled = isEverythingOk;
		this.isCustomfieldFulfilled.emit(this._isCustomfieldFulfilled);
		this.customfields.emit(this._customfields);
	}

	showHiddenFields(customfield: genericFormInterface): void {
		for (let index = 0; index < customfield.items.length; index++) {
			const item: genericFormInterface = customfield.items[index];
			if (!item.subSelect || item.subSelect.length === 0) continue;
			for (const subSelect of item.subSelect) {
				if (this.customfieldDictionary[subSelect.subSelectChildName] != undefined) {
					this.customfieldDictionary[subSelect.subSelectChildName].hidden =
						this.customfieldDictionary[subSelect.subSelectChildName].rawHidden;
					this.customfieldDictionary[subSelect.subSelectChildName].values[0] = '';
					this.customfieldDictionary[subSelect.subSelectChildName].required =
						this.customfieldDictionary[subSelect.subSelectChildName].rawRequired;
				}
			}
		}

		for (let index = 0; index < customfield.items.length; index++) {
			const item: genericFormInterface = customfield.items[index];
			if (!item.subSelect || item.subSelect.length === 0 || item.value != customfield.values[0]) continue;

			for (const subSelect of item.subSelect) {
				if (this.customfieldDictionary[subSelect.subSelectChildName] != undefined) {
					this.customfieldDictionary[subSelect.subSelectChildName].hidden = '0';
					this.customfieldDictionary[subSelect.subSelectChildName].required =
						subSelect.make_required == true ? true : this.customfieldDictionary[subSelect.subSelectChildName].rawRequired;
				}
			}
			break;
		}

		this.verifyCustomfieldValues(false);
	}

	setHiddenCustomfields(): void {
		for (const cf of this._customfields) {
			if (
				(cf.inputType === 'select' || cf.inputType === 'select-iac' || cf.inputType === 'select-approver') &&
				cf.values[0] &&
				cf.values[0].toString().trim() != ''
			) {
				for (const index in cf.items) {
					const item = cf.items[index];
					if (item.values[0] != cf.values[0]) continue;

					if (item.subSelect?.length > 0) {
						for (const subSelect of item.subSelect) {
							if (this.customfieldDictionary[subSelect.subSelectChildName] != undefined)
								this.customfieldDictionary[subSelect.subSelectChildName].hidden = '0';
						}
					}
					break;
				}
			}
		}
	}

	getCustomfieldsByClassification(): void {
		this.RequestCustomfieldService.getCustomfieldsByClassification(this.idTopic, this.idCategory, this.idSolutionArea).subscribe({
			next: (customfield) => {
				this._customfields = customfield.map((customfield) => {
					if (customfield.required == 2) customfield.hidden = true;
					if (!this.ignoreAnalystView && customfield.analystView == true && !this.isAnalystView) customfield.hidden = true;
					return customfield;
				});

				for (let index = 0; index < this._customfields.length; index++) {
					const cf = this._customfields[index];
					if (
						cf.inputType === 'string' ||
						cf.inputType == 'multi-select' ||
						cf.inputType == 'radio' ||
						cf.inputType == 'checkbox' ||
						cf.inputType === 'attachment' ||
						cf.inputType === 'textarea'
					) {
						cf.extraFunction = () => {
							this.verifyCustomfieldValues(false);
						};
					}
					if (
						(cf.inputType === 'select' || cf.inputType === 'select-iac' || cf.inputType === 'select-approver') &&
						cf.rawInputType !== 'json_dynamic'
					) {
						cf.extraFunction = () => {
							this.verifyCustomfieldValues(false);
							this.showHiddenFields(cf);
						};
					}
					if (cf.rawInputType === 'json_dynamic') cf.inputType = 'select-iac';
					this.customfieldDictionary[cf.id] = cf;
				}

				this.setHiddenCustomfields();
				this.verifyCustomfieldValues(false);
				this.lockFields(this.disabled);
				// this.formatMultiValuesCustomfield();
			},
			complete: () => {
				this._isCustomfieldLoading = false;
				this.isCustomfieldLoading.emit(this._isCustomfieldLoading);
			},
		});
	}

	getCustomfieldByCustomfield(): void {
		for (let index = 0; index < this._customfields.length; index++) {
			const cf = this._customfields[index];
			if (
				cf.inputType === 'string' ||
				cf.inputType == 'multi-select' ||
				cf.inputType == 'radio' ||
				cf.inputType == 'checkbox' ||
				cf.inputType === 'attachment' ||
				cf.inputType === 'textarea'
			) {
				cf.extraFunction = () => {
					this.verifyCustomfieldValues(false);
				};
			}
			if (
				(cf.inputType === 'select' || cf.inputType === 'select-iac' || cf.inputType === 'select-approver') &&
				cf.rawInputType !== 'json_dynamic'
			) {
				cf.extraFunction = () => {
					this.verifyCustomfieldValues(false);
					this.showHiddenFields(cf);
				};
			}
			this.customfieldDictionary[cf.id] = cf;
		}

		this.setHiddenCustomfields();
		this.verifyCustomfieldValues(false);
		this.lockFields(this.disabled);
		// this.formatMultiValuesCustomfield();

		this._isCustomfieldLoading = false;
		this.isCustomfieldLoading.emit(this._isCustomfieldLoading);
	}

	getCustomfieldsByRequest(): void {
		this.RequestCustomfieldService.getCustomfieldsByRequest(this.idRequest).subscribe({
			next: (customfield) => {
				this._customfields = customfield.map((customfield) => {
					if (!this.ignoreAnalystView && customfield.analystView == true && !this.isAnalystView) customfield.hidden = true;
					return customfield;
				});

				for (let index = 0; index < this._customfields.length; index++) {
					const cf = this._customfields[index];
					if (
						cf.inputType === 'string' ||
						cf.inputType == 'multi-select' ||
						cf.inputType == 'radio' ||
						cf.inputType == 'checkbox' ||
						cf.inputType === 'attachment' ||
						cf.inputType === 'textarea'
					) {
						cf.extraFunction = () => {
							this.verifyCustomfieldValues(false);
						};
					}
					if (
						(cf.inputType === 'select' || cf.inputType === 'select-iac' || cf.inputType === 'select-approver') &&
						cf.rawInputType !== 'json_dynamic'
					) {
						cf.extraFunction = () => {
							this.verifyCustomfieldValues(false);
							this.showHiddenFields(cf);
						};
					}
					if (cf.rawInputType === 'json_dynamic') cf.inputType = 'select-iac';
					this.customfieldDictionary[cf.id] = cf;
				}

				this.setHiddenCustomfields();
				this.verifyCustomfieldValues(false);
				this.lockFields(this.disabled);
				// this.formatMultiValuesCustomfield()
			},
			complete: () => {
				this._isCustomfieldLoading = false;
				this.isCustomfieldLoading.emit(this._isCustomfieldLoading);
			},
		});
	}

	lockFields(lock: boolean): void {
		for (const cf of this._customfields) {
			// Implementação feita para desabilitar campos especificos para o usuário final baseado no campo analyst_view da tabela requests_fields
			cf.disabled = cf.disabled == true && !this.isAnalystView ? true : lock;

			if (lock == true) {
				if (cf.rawInputType != 'date' && cf.rawInputType != 'datetime') cf.inputType = 'string';
				if (cf.rawInputType === 'textarea') cf.inputType = 'textarea';
			} else {
				cf.inputType = cf.rawInputType === 'json_dynamic' ? 'select-iac' : cf.rawInputType;
			}
		}
	}
}
